export const SET_VEHICLE_VIEWS = 'SET_VEHICLE_VIEWS';
export const SET_NUMBER_OF_DAYS = 'SET_NUMBER_OF_DAYS';



// WEBPACK FOOTER //
// ./src/actions/types.js